import { useMutation,useQueries,useQuery } from "@tanstack/react-query";

export default class QueryFn {
  useFetch = <TData = unknown, TParam = unknown>(
    key: string,
    functionReceived: (value?: TParam) => Promise<TData> | TData,
    disable?: boolean,
    retryOnMount?: boolean,
  ) =>
    useQuery({
      queryKey: [key],
      queryFn: async (value?: unknown) => await functionReceived(value as TParam),
      enabled: disable,
      retry: false,
      refetchOnMount: retryOnMount !== undefined ? retryOnMount : true,
      refetchOnWindowFocus: false,
    });

  useMutate = <TData = unknown, TParam = unknown>(
    key: string,
    functionReceived: (params?: TParam) => Promise<TData> | TData,
  ) =>
    useMutation({
      mutationKey: [key],
      mutationFn: async (params?: unknown) => await functionReceived(params as TParam),
      retry: false,
    });

  useFetchMultiple = (queriesArr: { key: string; fn: (value?: unknown) => Promise<unknown> | unknown }[]) =>
    useQueries({
      queries: queriesArr?.map((elem) => {
        return {
          queryKey: [elem.key],
          queryFn: async (value?: unknown) => elem.fn(value),
          retry: false,
          refetchOnWindowFocus: false,
          refetchOnMount: true,
        };
      }),
    });
}